import React, { Fragment, useEffect, useState } from "react";
import { useSetState } from "Helpers/Hooks";
import MuiButton from "Components/MuiButton/MuiButton";
import Translator from "Languages/Utility/Translator";
import AuthHeader from "../../Auth/components/AuthHeader";
import Grid from "@material-ui/core/Grid";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Input from "Components/Input/Input";
import { read, store } from "Helpers/LocalStorage";
import StatusHandler from "Helpers/StatusHandler";
import PaymentService from "Services/http/endpoints/payment/PaymentService";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import MaxFourNumber from "Components/Input/components/MaxFourNumber";
import showNotify from "Helpers/Notify";
import { toggleNPaymentType } from "Constants/Constants";
import * as R from "ramda";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import PageTitle from "Components/PageTitle/PageTitle";
import { push } from "Helpers/History";
import { readRefreshToken, storeToken } from "Helpers/Token";
import * as Icons from "react-bootstrap-icons";
import AppLogo from "Assets/svg/logo/logo.svg";
import AppLogoText from "Assets/svg/logo/logo-text.svg";
import { useTranslation } from "react-i18next";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import PaymentDetailsItems from "./PaymentDetailsItems";

function Payment() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [isDiscount, setIsDiscount] = useState(false);
  const [dataCalculate, setDataCalculate] = useState([]);
  const [isShowDetails, setIsShowDetails] = useState(false);
  const [saleDefaultPeriod, setSaleDefaultPeriod] = useState([]);
  const [formValid, setFormValid] = useState({ discount: true });
  const [isSendValidate, setIsSendValidate] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [limitedTimeModule, setLimitedTimeModule] = useState(false);
  const [price, setPrice] = useState("?");

  const [controls, setControls] = useSetState({
    usingTime: {
      selectItems: [],
      value: "",
      validation: {
        required: true,
      },
    },
    numberUsers: {
      value: "",
      validation: {
        isNumeric: true,
        min: 3,
        max: 1000,
      },
    },
    payType: {
      arrayItems: toggleNPaymentType,
      value: toggleNPaymentType[1],
      validation: {
        required: true,
      },
    },
    discount: {
      value: "",
    },
  });

  const autoCompleteHandlerUsers = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const handleDialogDefaultPeriod = (item) => {
    const foundPeriod = controls.usingTime.selectItems.find((option) => {
      return option.value === item.PeriodId;
    });
    setControls({ usingTime: { value: foundPeriod } });
    setControls({ numberUsers: { value: item.Count } });
    const cnu = document.getElementById("change-number-users");
    cnu.classList.add("change-to-active-element");
    setTimeout(() => {
      cnu.classList.remove("change-to-active-element");
    }, 500);
  };

  const onClickCalculate = async () => {
    if (Object.values(formValid).every((item) => item === true)) {
      const { numberUsers, usingTime, discount } = controls;
      try {
        setLoading(true);
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          PeriodId: usingTime.value.value,
          Count: numberUsers.value,
          DiscountCode: discount.value,
          UserProductChange: [],
        };
        const response = await PaymentService.postSaleCalculate(data);
        let err = StatusHandler(response);
        if (!err.isFail) {
          const saleCalculate = response.data.Value;
          setDataCalculate(saleCalculate);
          setPrice(saleCalculate?.PriceShow);
          setIsSendValidate(false);
          if (saleCalculate.ValidationCount.Users.length > numberUsers.value) {
            setIsSendValidate(true);
            showNotify({
              text: t("requestedUsersNumberProblem"),
              customClass: "error",
            });
          } else {
            setIsSendValidate(false);
          }
        }
      } catch (err) {
        console.error("[catch error]", err);
      }
    }
    setLoading(false);
  };

  const onChangeRadio = (name, key, value) => {
    setControls({ [name]: { value: value } });
  };

  const onFinish = async (e) => {
    e.preventDefault();
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      const { numberUsers, usingTime, payType, discount } = controls;
      try {
        setLoading(true);
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          PeriodId: usingTime.value.value,
          Count: numberUsers.value,
          TypePayment: +payType.value.value,
          DiscountCode: discount.value,
          UserProductChange: [],
        };
        const response = await PaymentService.postTypePayment(data);
        let err = StatusHandler(response);
        if (!err.isFail) {
          const pay = response.data.Value;
          if (+payType.value.value === 1 && pay.IsError === false) {
            let link = pay.Link;
            if (link.substr(link.indexOf("token=")).length > 10) {
              store("orderId", pay.Describ);
              window.open(pay.Link, "_self");
            }
          } else if (+payType.value.value === 1 && pay.IsError === true) {
            showNotify({
              text: pay.Describ,
              customClass: "error",
            });
          }
          if (+payType.value.value === 2 && pay.IsError === false) {
            showNotify({
              text: pay.Describ,
              customClass: "success",
            });
            const params = {
              TokenKey: read("userKey"),
              TokenRef: readRefreshToken(),
            };
            const response = await PaymentService.GetRefreshToken(params);
            const { data } = response;
            if (data["StatusCode"] === 200) {
              storeToken(data.Value.Token, data.Value["RefreshToken"]);
              push("/dashboard/payment/information-panel");
            } else if (data["StatusCode"] === -2) {
              const project = read("project");
              const unitId = read("unitId");
              const userId = read("userId");
              localStorage.clear();
              store("project", project);
              store("unitId", unitId);
              store("userId", userId);
              push("/");
              window.location.reload();
            }
          } else if (+payType.value.value === 2 && pay.IsError === true) {
            showNotify({
              text: pay.Describ,
              customClass: "error",
            });
          }
        }
        setLoading(false);
      } catch (e) {
        showNotify({
          text: t("correctFormDataRequired"),
          customClass: "error",
        });
        setLoading(false);
      }
    } else {
      showNotify({
        text: t("correctFormDataRequired"),
        customClass: "error",
      });
    }
  };

  useEffect(() => {
    setLimitedTimeModule(false);
    (async () => {
      try {
        setIsSendValidate(true);
        setLoading(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
        };
        const responseUsingTime = await PaymentService.GetSalePeriod(params);
        let err = StatusHandler(responseUsingTime);
        if (!err.isFail) {
          const optionsUsingTime = responseUsingTime.data.Value.map(
            (option) => {
              return {
                ...option,
                label: option.Name,
                value: option.Id,
              };
            }
          );
          setControls({ usingTime: { selectItems: optionsUsingTime } });

          const response = await PaymentService.GetSaleUsingTime(params);
          let e = StatusHandler(response);
          if (!e.isFail) {
            const options = response.data.Value;
            const value = optionsUsingTime.find((option) => {
              return option.value === options.PeriodId;
            });
            setControls({ usingTime: { value: value } });
            setControls({ numberUsers: { value: options.Count } });
            const lastValidation = controls.numberUsers.validation;
            setControls({
              numberUsers: {
                validation: { ...lastValidation, min: options.MinCount },
              },
            });
          }
        }
        const responseSaleDefault = await PaymentService.GetSaleDefault(params);
        let er = StatusHandler(responseSaleDefault);
        if (!er.isFail) {
          const options = responseSaleDefault.data.Value;
          setSaleDefaultPeriod(options);
        }

        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    setIsSendValidate(true);
    setIsShow(true);
    setPrice("?");
  }, [controls.usingTime, controls.numberUsers, controls.discount]);

  const onClickDiscount = () => {
    setIsDiscount(true);
  };

  const onClickViewDetails = () => {
    setIsShowDetails(true);
    setIsShow(false);
  };

  function LimitedTimeModule() {
    return (
      <div className="payment-banner-main">
        <div className="payment-banner">
          <div className="inner p-3">
            <div className="logo">
              <img
                src={AppLogo}
                alt="session-logo"
                height="50"
                className="ml-1"
              />
              <img src={AppLogoText} alt="session-logo" height="55" />
            </div>
            <h2>جـــــشـنـواره فـــــروش</h2>

            <p>
              از تاریخ : <strong className="ml-4">20 تیرماه 1402</strong> تا
              تاریخ : <strong>10 مردادماه 1402</strong>
            </p>

            <p>
              قیمت هر اکانت یک ساله :{" "}
              <strong>
                <del>{(1800000).toLocaleString()}</del> تومان
              </strong>{" "}
              <span>
                <Icons.CaretLeft size={40} />
              </span>{" "}
              قیمت جشنواره : <strong>{(1200000).toLocaleString()} تومان</strong>
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <BackDropLoading loading={loading} />
      <PageTitle className="my-4" title={<Translator id={"purchase_form"} />} />
      {limitedTimeModule && <LimitedTimeModule />}
      <Grid container spacing={2}>
        <Grid item lg={4} md={6} sm={12} xs={12}>
          <MuiPaper>
            <Grid container spacing={1} className="p-3">
              {!limitedTimeModule && (
                <Grid item xs={12} className="mb-4">
                  <AuthHeader description={t("basedOnUserOffers")} />
                  <div className="payment-default-period">
                    {saleDefaultPeriod.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="payment-default-period-items"
                          onClick={() => handleDialogDefaultPeriod(item)}
                        >
                          <p>{item.Description}</p>
                        </div>
                      );
                    })}
                    <span className="info-text">
                      <Icons.InfoCircle /> {t("basedOnUserOffersInfo")}
                    </span>
                  </div>
                </Grid>
              )}
              <Grid item sm={6} xs={12}>
                <MuiAutoComplete
                  loading={loading}
                  options={controls.usingTime.selectItems}
                  label={<Translator id={"usingTime"} />}
                  value={controls.usingTime.value}
                  id="usingTime"
                  onChange={autoCompleteHandlerUsers}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <Input
                  setValue={setValue.bind(this)}
                  id="change-number-users"
                  options={controls.numberUsers.selectItems}
                  value={controls.numberUsers.value}
                  validation={controls.numberUsers.validation}
                  label={<Translator id={"numberUsers"} />}
                  type="text"
                  icon={<Icons.Person />}
                  name="numberUsers"
                  inputComponent={MaxFourNumber}
                />
              </Grid>
              {!isDiscount ? (
                <Grid item xs={12} className="pt-0 pb-2">
                  <MuiButton
                    className="link p-1 pt-0"
                    title={t("haveDiscountCode")}
                    onClick={onClickDiscount}
                  />
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <Input
                    label={<Translator id={"discountCode"} />}
                    setValue={setValue.bind(this)}
                    value={controls.discount.value}
                    name="discount"
                    type="text"
                    placeholder={t("enterDiscountCode")}
                  />
                </Grid>
              )}
              <Grid item sm={7} xs={12}>
                <MuiButton
                  className="w-100"
                  color="primary"
                  title={<Translator id="priceCalculation" />}
                  onClick={onClickCalculate}
                />
              </Grid>
              <Grid item sm={5} xs={12}>
                <MuiButton
                  className="w-100"
                  color="secondary"
                  title={<Translator id="purchaseDetails" />}
                  onClick={onClickViewDetails}
                  disabled={isSendValidate}
                />
              </Grid>
            </Grid>
          </MuiPaper>
        </Grid>
        <Grid item lg={4} md={6} sm={12} xs={12}>
          <MuiPaper>
            <Grid container spacing={1} className="p-3">
              <Grid item xs={12} className="payment-price-show">
                <div>
                  <span className="upper-text">{t("totalPayment") + ":"}</span>
                  <p>{price.toLocaleString()}</p>
                  <Translator id="moneyUnit" />
                </div>
                {price === "?" && (
                  <span className="calc-info-text">
                    {t("paymentCalcInfoPage")}
                  </span>
                )}
              </Grid>
              <span className="calc-warn-text">
                {t("priceWithTax")}
              </span>
              <Grid item xs={12} className="mt-2">
                <MuiRadioGroup
                  label={<Translator id={"paymentType"} />}
                  name="payType"
                  value={controls.payType.value}
                  items={controls.payType.arrayItems}
                  translate={true}
                  onChange={onChangeRadio}
                  className="horizontalRadio"
                />
              </Grid>
              <Grid item xs={12}>
                <MuiButton
                  className="w-100"
                  color="primary"
                  title={<Translator id="payment" />}
                  disabled={isSendValidate}
                  onClick={onFinish}
                />
              </Grid>
            </Grid>
          </MuiPaper>
        </Grid>
      </Grid>
      {!isShow && isShowDetails && (
        <PaymentDetailsItems title={"purchaseDetails"} data={dataCalculate} />
      )}
    </>
  );
}

export default Payment;
